import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: null,
    isAuthenticated: false,
    authInProgress: false,
    loading: false,
    error: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            state.isAuthenticated = true;
            state.authInProgress = false;
            state.loading = false;
            state.error = null;
        },
        setAuthInProgress: (state, action) => {
            state.authInProgress = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        logout: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.authInProgress = false;
            state.loading = false;
            state.error = null;
            localStorage.removeItem('user');
        }
    }
});

export const { setUser, setLoading, setError, setAuthInProgress, logout } = authSlice.actions;
export default authSlice.reducer; 